export default __webpack_public_path__ + "static/media/product2.fe12d25d.JPG";